import { LoadingButton } from "@mui/lab";
import { Stack } from "@mui/material";
import { FormProvider, RHFTextField } from "src/components/hook-form";
import useLocales from "src/hooks/useLocales";

import useEmailForm from "../hooks/useEmailForm";

// ----------------------------------------------------------------------

export const EmailInput = () => {
	const { methods, onSubmit, loading } = useEmailForm();
	const { translate } = useLocales();
	return (
		<FormProvider methods={methods} onSubmit={onSubmit}>
			<Stack
				sx={{ mt: { xs: 5, sm: 4 } }}
				flexDirection={{ xs: "column", sm: "row" }}
				gap={{ xs: 5, sm: 4 }}
				alignItems={"center"}
			>
				<RHFTextField
					label='Email'
					sx={{ flexGrow: 1, width: "100%" }}
					type='email'
					name={"email"}
				/>
				<LoadingButton variant='contained' size='medium' type='submit' loading={loading}>
					{translate("demo.send")}
				</LoadingButton>
			</Stack>
		</FormProvider>
	);
};

export default EmailInput;
